import React from 'react';
import moment from 'moment';
import { Box, Checkbox, IconButton, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

const useStyles = makeStyles(() => ({
    chip: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: '8px 12px',
        borderRadius: 12,
        border: '1px solid rgba(148, 163, 184, 0.35)',
        backgroundColor: '#ffffff',
        boxShadow: '0 8px 18px rgba(15, 23, 42, 0.08)',
    },
    sharedChip: {
        backgroundColor: 'rgba(15, 23, 42, 0.92)',
        borderColor: 'rgba(15, 23, 42, 0.7)',
    },
    textBlock: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        minWidth: 0,
    },
    title: {
        fontSize: '0.92rem',
        fontWeight: 600,
        color: '#0f172a',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    sharedTitle: {
        color: '#f8fafc',
    },
    subtitle: {
        fontSize: '0.75rem',
        color: 'rgba(248, 250, 252, 0.7)',
    },
    checkbox: {
        padding: 4,
    },
    closeButton: {
        padding: 4,
        color: '#f8fafc',
        borderRadius: 8,
        border: '1px solid rgba(248, 250, 252, 0.2)',
        '&:hover': {
            backgroundColor: 'rgba(248, 250, 252, 0.15)',
        },
    },
}));

const SubAccountVehicleCard = ({ asset, shared, selected, onSelect, onUnshare }) => {
    const classes = useStyles();
    const handleSelect = () => {
        if (onSelect) {
            onSelect(asset.assetId);
        }
    };

    const handleUnshare = () => {
        if (onUnshare) {
            onUnshare(asset.assetId);
        }
    };

    return (
        <Box className={`${classes.chip} ${shared ? classes.sharedChip : ''}`}>
            <Box className={classes.textBlock}>
                <Typography className={`${classes.title} ${shared ? classes.sharedTitle : ''}`}>
                    {asset.regn}
                </Typography>
                {shared && asset.access_upto ? (
                    <Typography className={classes.subtitle}>
                        Till: {moment(asset.access_upto).format("D-MMM 'YY")}
                    </Typography>
                ) : null}
            </Box>
            {shared ? (
                <IconButton onClick={handleUnshare} className={classes.closeButton} size="small">
                    <Icon path={mdiClose} size={0.7} color="currentColor" />
                </IconButton>
            ) : (
                <Checkbox
                    checked={Boolean(selected)}
                    onChange={handleSelect}
                    size="small"
                    className={classes.checkbox}
                />
            )}
        </Box>
    );
};

export default SubAccountVehicleCard;
